import { render, staticRenderFns } from "./ImageModal.vue?vue&type=template&id=af61ea0e&scoped=true&"
import script from "./ImageModal.vue?vue&type=script&lang=js&"
export * from "./ImageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af61ea0e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ObjectsPublicTheExportNew: require('/web/components/objects/public/TheExportNew.vue').default})
